import React from "react";
import SaudiRegionsAndCities from "../SaudiRegionsAndCities/SaudiRegionsAndCities";

export default function CompanyInput({
  onInputChange,
  companyData,
  fieldErrors,
}) {
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    onInputChange(name, value);
  };

  // Handle location changes
  const handleLocationChange = (type, value) => {
    onInputChange(type, value);
  };

  return (
    <>
      <section className="row mb-5">
        <h4>
          <span>بيانات الشركة</span>
        </h4>
        <div className="col-12 mt-3 mb-2">
          <div>
            <label htmlFor="companyName">
              اسم الشركه
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="companyName"
              value={companyData?.companyName || ""}
              placeholder="اسم الشركه"
              id="companyName"
              className={`form-control ${
                fieldErrors?.companyName ? "is-invalid" : ""
              }`}
              onChange={handleChange}
            />
            {fieldErrors?.companyName && (
              <div className="invalid-feedback d-block">
                {fieldErrors.companyName}
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="row mb-5">
        <h4>
          <span>عنوان الشركة</span>
        </h4>
        <SaudiRegionsAndCities
          companyData={companyData}
          handleChange={onInputChange}
          onLocationChange={handleLocationChange}
          fieldErrors={fieldErrors}
        />
      </section>

      <section className="row mb-3">
        <h4>
          <span>بيانات التواصل</span>
        </h4>
        <div className="col-md-6 mb-2">
          <div>
            <label htmlFor="phone" className="mt-3">
              رقم الهاتف
            </label>
            <input
              type="text"
              name="phone"
              value={companyData?.phone || ""}
              placeholder="رقم الهاتف"
              id="phone"
              className={`form-control ${
                fieldErrors?.phone ? "is-invalid" : ""
              }`}
              onChange={handleChange}
            />
            {fieldErrors?.phone && (
              <div className="invalid-feedback d-block">
                {fieldErrors.phone}
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div>
            <label htmlFor="email" className="mt-3">
              البريد الاليكتروني
            </label>
            <input
              type="email"
              name="email"
              value={companyData?.email || ""}
              placeholder="البريد الاليكتروني"
              id="email"
              className={`form-control ${
                fieldErrors?.email ? "is-invalid" : ""
              }`}
              onChange={handleChange}
            />
            {fieldErrors?.email && (
              <div className="invalid-feedback d-block">
                {fieldErrors.email}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
